/*
* @Author: yongwenhao
* @Date: 2020-04-17 09:51:22
* @describe: 表单邮箱配置
*/
import axios from './http'

// 查询表单接收人列表
export const GetReceiverList = params => {
    return axios.get("/receiver", {params}).then(res => res.data)
};
// 增加表单接收人
export const PostAddReceiver = params => {
    return axios.post("/receiver", params).then(res => res.data)
};
// 修改表单接收人
export const PutEditReceiver = params => {
    return axios.put("/receiver", params).then(res => res.data)
};
// 删删除表单接收人
export const DelReceiver = receiverId => {
    return axios.delete(`/receiver/${receiverId}`).then(res => res.data)
};
